import { render } from "./Village.vue?vue&type=template&id=01aeb773"
import script from "./Village.vue?vue&type=script&lang=js"
export * from "./Village.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/Village.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01aeb773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01aeb773', __exports__)) {
    api.reload('01aeb773', __exports__)
  }
  
  module.hot.accept("./Village.vue?vue&type=template&id=01aeb773", () => {
    api.rerender('01aeb773', render)
  })

}


export default __exports__